const CancelToken = window.axios.CancelToken;
let iSource;

export default {
  get(context, params) {
    return new Promise((resolve, reject) => {
      const config = params?.cancelTokenSource
        ? { cancelToken: params.cancelTokenSource.token }
        : {};
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/scrambled/reports/order?${queryString}`, config)
        .then(({ data: { count, next, previous, results } }) => {
          context.commit("setSales", results);
          context.commit("setPagination", {
            count,
            next,
            previous
          });
          resolve({ count, next, previous, results });
        })
        .catch(reject);
    });
  },
  getCount(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/scrambled/reports/order?${queryString}`)
        .then(({ data: { count } }) => {
          resolve(count);
        })
        .catch(reject);
    });
  },
  getCSV(context, params) {
    return new Promise((resolve, reject) => {
      const config =
        params.export_format === "excel" ? { responseType: "blob" } : null;
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/scrambled/reports/order?${queryString}`, config)
        .then(({ data }) => {
          resolve({ data });
        })
        .catch(reject);
    });
  },
  getSale(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/scrambled/reports/order/${id}`)
        .then(({ data }) => {
          context.commit("setSale", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  refund(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/scrambled/order/reserval-payment/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  getTotal(context, filters) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(filters).toString();
      return window.axios
        .get(`/sales/total?${queryString}`)
        .then(({ data: { amount__sum } }) => {
          context.commit("setTotalAmount", amount__sum);
          resolve(amount__sum);
        })
        .catch(reject);
    });
  },
  getInitiateCheckout(context, filters) {
    return new Promise((resolve, reject) => {
      let queryString = "";
      if (Object.entries(filters).length) {
        queryString = new URLSearchParams(filters).toString();
      }
      return window.axios
        .get(`/scrambled/reports/recover?${queryString}`)
        .then(({ data: { count, next, previous, results } }) => {
          context.commit("setInitiateCheckout", results);
          context.commit("setPagination", {
            count,
            next,
            previous
          });
          resolve(results);
        })
        .catch(reject);
    });
  },
  exportInitiateCheckout(context, params) {
    const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`scrambled/reports/recover?${queryString}`)
        .then(data => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  getInstallments(context, params) {
    if (iSource) {
      iSource.cancel();
    }
    iSource = CancelToken.source();
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/sales/parcels?${queryString}`, { cancelToken: iSource.token })
        .then(({ data }) => {
          context.commit("setInstallments", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  getTotalSales(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`scrambled/reports/total/sales?${queryString}`)
        .then(({ data: { total_amount } }) => {
          context.commit("setTotalAmount", total_amount);
          resolve(total_amount);
        })
        .catch(reject);
    });
  }
};
